
import post from '@/mixins/post-data.js'
import seo from '@/mixins/seo.js'
import helpers from '@/mixins/helpers.js'

export default {
  // post ritorna page e seo data
  mixins: [post, seo, helpers],
}
